
  import { defineComponent } from "vue";

  export default defineComponent({
    computed: {
      showNavbar(): boolean {
        return (
          this.$route.name !== "Home" &&
          this.$route.name !== "Redirect" &&
          this.$route.name !== "Register"
        )
      },
    },

    mounted() {
    },
  });
  